// Linear shows an unnamed cycle by its number, so we do the same.
export function cycleLabel(cycle: {
	number: number
	name?: string | null
}): string {
	return cycle.name?.trim() || `Cycle ${cycle.number}`
}
